import * as React from 'react';
import cx from 'clsx';

import styles from './LayersWrapper.module.scss';

interface LayersWrapperProps {
  rounded?: 'all' | 'top';
  children?: React.ReactNode;
}

const LayersWrapper = ({ children, rounded }: LayersWrapperProps) => {
  let borderClass;

  if (rounded === 'top') borderClass = styles.roundedTop;
  if (rounded === 'all') borderClass = styles.rounded;

  return (
    <div
      className={cx(styles.container, borderClass)}
      data-testid="layers-wrapper-element"
    >
      {children}
    </div>
  );
};

export default LayersWrapper;
